import Box from "@/common/components/Box";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import ResumeItem from "@/common/components/ResumeItem";
import { cn } from "@/common/utils/cn";
import { Building2Icon } from "lucide-react";
import { MaintenanceForwardingSectionsProps } from "../../../../../features/forwardings/types/maintenanceForwarding.type";
import ManualEntryProposalsClientAccept from "./ManualEntryProposals/ClientAccept";
import EstablishmentChoiceEntryProposal from "./Proposal";
import ManualEntryProposalsClientReject from "./ManualEntryProposals/ClientReject";

const MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection = ({
  forwarding,
}: MaintenanceForwardingSectionsProps) => {
  const isAwaitingClientResponse = forwarding.establishment_choice_entry.actual_proposal.status === 'awaiting_client_response';

  return (
    <Box className={cn(
      'p-4 flex flex-col gap-4',
      isAwaitingClientResponse && 'bg-yellow-op-2',
    )}>
      <div className="flex items-center gap-2 justify-between">
        <div>
          <p className="text-lg font-semibold">
            Estabelecimento para Diagnóstico e Orçamento
          </p>
        </div>

        {isAwaitingClientResponse && (
          <div className="flex items-center gap-3">
            <ManualEntryProposalsClientReject
              proposal={forwarding.establishment_choice_entry.actual_proposal}
            />

            <ManualEntryProposalsClientAccept
              proposal={forwarding.establishment_choice_entry.actual_proposal}
            />
          </div>
        )}
      </div>

      <div className="flex items-center gap-3">
        {forwarding?.establishment_choice_entry?.establishment && (
          <ResumeItem
            label="Estabelecimento escolhido"
            value={(
              <ImageWithDisplayName
                placeholderIcon={Building2Icon}
                imageUrl={forwarding?.establishment_choice_entry?.establishment.general_information.company_logo?.url}
                displayName={forwarding?.establishment_choice_entry?.establishment.general_information.fantasy_name || '--'}
                containerClassName="gap-1.5"
                imageClassName="size-5"
                iconClassName="size-3.5"
                displayNameClassName="text-xs"
              />
            )}
            className="text-xs"
            containerClassName="gap-1"
            valueClassName="font-bold text-sm"
          />
        )}
      </div>

      {forwarding?.establishment_choice_entry?.actual_proposal && (
        <EstablishmentChoiceEntryProposal
          proposal={forwarding?.establishment_choice_entry?.actual_proposal}
        />
      )}
    </Box>
  )
}

export default MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection;
